import React from 'react';
import ExtraProjects from './ExtraProjects/ExtraProjects';
import PopularProjects from './PopularProjects/PopularProjects';
import TeamProjects from './TeamProjects/TeamProjects';

const Projects = () => {
    return (
        <div>
            <h1 style={{marginTop:"30px"}} className="text-center text-light myProjectText"><i><b>My projects</b></i></h1>
            <TeamProjects/>
            <PopularProjects></PopularProjects>
            <ExtraProjects></ExtraProjects>
        </div>
    );
};

export default Projects;